import { render, staticRenderFns } from "./trans-promise-info.html?vue&type=template&id=594ef786&scoped=true&external"
import script from "./trans-promise-info.js?vue&type=script&lang=js&external"
export * from "./trans-promise-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-promise-info.scss?vue&type=style&index=0&id=594ef786&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ef786",
  null
  
)

export default component.exports